module.exports = __webpack_public_path__ + "static/media/img-promising-company@3x.2c51afac.png";